import { useCallback, useState } from "react";

import AuthenticationTwoFactorEnrollment from "./AuthenticationTwoFactorEnrollment";
import AuthenticationTwoFactorChallenge from "./AuthenticationTwoFactorChallenge";

const TWO_FACTOR_CHALLENGE = "CHALLENGE";
const TWO_FACTOR_ENROLLMENT = "ENROLLMENT";

const AuthenticationTwoFactorManager = props => {
  const { onSignIn, twoFactorStep: initialTwoFactorStep } = props;

  const [twoFactorStep, setTwoFactorStep] = useState(initialTwoFactorStep);

  const handleEnrolled = useCallback(() => setTwoFactorStep(TWO_FACTOR_CHALLENGE), []);

  if (!twoFactorStep) return null;

  if (twoFactorStep === TWO_FACTOR_ENROLLMENT) {
    return <AuthenticationTwoFactorEnrollment onEnrolled={handleEnrolled} />;
  }

  if (twoFactorStep === TWO_FACTOR_CHALLENGE) {
    return <AuthenticationTwoFactorChallenge onSignIn={onSignIn} />;
  }
};

export default AuthenticationTwoFactorManager;
